import { z } from "zod";

export const ChartType = {
	BAR: "bar",
	PIE: "pie",
	LINE: "line",
	SCATTER: "scatter",
	AREA: "area",
	TABLE: "table",
} as const;
export type ChartType = (typeof ChartType)[keyof typeof ChartType];

export const chartAxisSchema = z.object({
	key: z.string().min(1),
	label: z.string().min(1),
});

export const chartRecommendationSchema = z.object({
	type: z.enum(ChartType),
	title: z.string().min(1),
	x_axis: chartAxisSchema.nullable(),
	y_axis: chartAxisSchema.nullable(),
	series: z.array(z.string()).default([]),
	confidence: z.number().min(0).max(1),
	reasoning: z.string(),
});

export type ChartAxis = z.infer<typeof chartAxisSchema>;
export type ChartRecommendation = z.infer<typeof chartRecommendationSchema>;
